import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

import { AppDispatch } from '../../store/store';
import { setLoggedInUser } from '../../features/User/userSlice';
import { fetchCertificates } from '../../features/Certificates/certificatesSlice';
import { useLoader } from '../../context/LoaderContext';
import { StorageService, STORAGE_KEYS } from '../../utils/storageService';

const AuthCallback: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { setLoading } = useLoader();
  const urlParams = new URLSearchParams(window.location.search);
  const accessToken = urlParams.get('access_token') as string;
  const access_token_expiry = urlParams.get('token_expiry') as string;
  const selectedLanguage = urlParams.get('language') as string;

  localStorage.setItem('access_token', accessToken);
  localStorage.setItem('token_expiry', access_token_expiry);
  localStorage.removeItem('lookupData');
  if(selectedLanguage){
    localStorage.setItem('selectedLang', selectedLanguage);
  }

  useEffect(() => {
    if (!localStorage.getItem('access_token')) {
      const urlParams = new URLSearchParams(window.location.search);

      const accessToken = urlParams.get('access_token');
      const access_token_expiry = urlParams.get('token_expiry');
      const redirect_url = urlParams.get('redirect_url');

      if (!accessToken || !access_token_expiry || !redirect_url) {
        console.error("Missing necessary parameters in the URL");
        navigate('/login');
        return;
      }

      localStorage.setItem('access_token', accessToken);

      if (!isNaN(Number(access_token_expiry))) {
        localStorage.setItem('token_expiry', access_token_expiry);
      } else {
        console.error("Invalid token expiry in URL:", access_token_expiry);
        navigate('/login');
        return;
      }
    }

    // Store LoggedIn User Information
    const decodedToken: any = jwtDecode(accessToken);
    dispatch(setLoggedInUser(decodedToken))
  
    const loadCertificates = async () => {
      setLoading(true);
      const resultAction = await dispatch(fetchCertificates());
      if (fetchCertificates.fulfilled.match(resultAction)) {
        const certificates = resultAction.payload;
        if (certificates.length === 1) {
          StorageService.set(STORAGE_KEYS.CERTIFICATE, certificates[0]);
          navigate(`/dashboard/${certificates[0].id}`);
          setLoading(false);
          return;
        } else {
          navigate('/certificates');
          setLoading(false);
          return;
        } 
      } else {
        navigate('/certificates');
        setLoading(false);
        return;
      }
    };

    // Call service to check how many certificates are present. If it has more than 1 then certificates then navigate to certificate list screen else navigate to logo reguest page
    loadCertificates();
  }, [navigate]);

  return <div>Redirecting...</div>;
};

export default AuthCallback;
